/* eslint-disable */
export default {
  attachFiles: 'Datei anhängen',
};

// @key: @#@"attachFiles"@#@ @source: @#@"Attach file"@#@
